import { PluTypes, computeCompositePlu, getVendorConfig } from '../vendor-config';

import { IItemOptionModifierPluIsAvailable } from './types';

import { pluIsAvailable } from '.';

export const itemOptionModifierPluIsAvailable = ({
  item,
  itemOptionModifier,
  vendor,
  prices,
}: IItemOptionModifierPluIsAvailable): boolean => {
  const vendorConfig = getVendorConfig(itemOptionModifier, vendor);

  if (vendorConfig && vendorConfig.pluType === PluTypes.IGNORE) {
    return true;
  }

  const compositePlu = computeCompositePlu({ parent: item, child: itemOptionModifier, vendor });

  return pluIsAvailable(compositePlu, prices);
};
